import { OrderDraftArticleRow } from "types";

const normalizeGroupedOutcomeValue = (value: unknown) => {
  if (value === null || value === undefined || value === "") {
    return "__null__";
  }

  return String(value);
};

export const shouldResetOrderArticleObservationPreview = (
  previousArticle: OrderDraftArticleRow,
  nextArticle: OrderDraftArticleRow,
) =>
  previousArticle.amount !== nextArticle.amount ||
  previousArticle.article_id !== nextArticle.article_id ||
  (previousArticle.article_location_id ?? null) !==
    (nextArticle.article_location_id ?? null) ||
  (previousArticle.location_id ?? null) !== (nextArticle.location_id ?? null) ||
  normalizeGroupedOutcomeValue(previousArticle.lote) !==
    normalizeGroupedOutcomeValue(nextArticle.lote) ||
  normalizeGroupedOutcomeValue(previousArticle.oc) !==
    normalizeGroupedOutcomeValue(nextArticle.oc) ||
  normalizeGroupedOutcomeValue(previousArticle.fecha_ingreso) !==
    normalizeGroupedOutcomeValue(nextArticle.fecha_ingreso) ||
  normalizeGroupedOutcomeValue(previousArticle.fecha_vencimiento) !==
    normalizeGroupedOutcomeValue(nextArticle.fecha_vencimiento) ||
  normalizeGroupedOutcomeValue(previousArticle.amount_per_container) !==
    normalizeGroupedOutcomeValue(nextArticle.amount_per_container);

export const buildOrderArticleLineData = (article: OrderDraftArticleRow) => {
  if (!article.stock_unit_selection) {
    return null;
  }

  return {
    stock_unit_selection: article.stock_unit_selection,
  };
};
